// ── AR Flow — NOVA INTERFACE, Etapa 2b: ações rápidas do cliente presencial ──
// Só aparece no card aberto ao lado da lista (layout "inline").
// Não grava nada sozinho: chama onDisqualify / onTransfer, que usam o mesmo
// onUpdate do card (a mesma gravação que a Central de Conversas já usa).

import { useState } from "react";

export default function ClientActionsBar({ theme, reasons, consultants, canTransfer, currentConsultantId, onDisqualify, onTransfer, busy }) {
  const th = theme;
  const [open, setOpen] = useState(null); // "desq" | "transf" | null
  const [reasonId, setReasonId] = useState("");
  const [reasonText, setReasonText] = useState("");
  const line = th.nuLine || th.sandDark;

  const btn = (active) => ({
    border: `1px solid ${active ? th.accent : line}`, background: active ? th.accent : "#fff",
    color: active ? "#fff" : th.text, borderRadius: 4, padding: "7px 12px", fontSize: 13,
    fontWeight: 600, cursor: busy ? "wait" : "pointer", fontFamily: "inherit",
  });
  const field = {
    width: "100%", padding: "8px 10px", borderRadius: 4, border: `1px solid ${line}`,
    fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", background: "#fff",
  };

  return (
    <div style={{ order: -2, marginBottom: 14 }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button type="button" disabled={busy} onClick={() => setOpen(open === "desq" ? null : "desq")} style={btn(open === "desq")}>
          Sem interesse
        </button>
        {canTransfer && (
          <button type="button" disabled={busy} onClick={() => setOpen(open === "transf" ? null : "transf")} style={btn(open === "transf")}>
            Transferir
          </button>
        )}
      </div>

      {open === "desq" && (
        <div style={{ marginTop: 10, padding: 12, border: `1px solid ${line}`, borderRadius: 4 }}>
          <label style={{ display: "block", fontSize: 12, fontWeight: 700, marginBottom: 6, color: th.text }}>Motivo</label>
          <select value={reasonId} onChange={e => setReasonId(e.target.value)} style={field}>
            <option value="">Selecione o motivo…</option>
            {reasons.map(r => <option key={r.id} value={r.id}>{r.label}</option>)}
          </select>
          <input value={reasonText} onChange={e => setReasonText(e.target.value)} placeholder="Detalhe (opcional)"
            style={{ ...field, marginTop: 8 }} />
          <button type="button" disabled={busy || !reasonId}
            onClick={() => onDisqualify(reasonId, reasonText.trim())}
            style={{ ...btn(true), marginTop: 10, opacity: reasonId ? 1 : 0.5 }}>
            Confirmar: mover para Sem interesse
          </button>
        </div>
      )}

      {open === "transf" && canTransfer && (
        <div style={{ marginTop: 10, padding: 12, border: `1px solid ${line}`, borderRadius: 4 }}>
          <label style={{ display: "block", fontSize: 12, fontWeight: 700, marginBottom: 6, color: th.text }}>Transferir para</label>
          <select value="" disabled={busy} onChange={e => { if (e.target.value) onTransfer(Number(e.target.value)); }} style={field}>
            <option value="">Selecionar consultor…</option>
            {(consultants || [])
              .filter(u => Number(u.id) !== Number(currentConsultantId))
              .map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
        </div>
      )}
    </div>
  );
}